import { render, staticRenderFns } from "./ArrobaMedellinVerticalCardEvents.html?vue&type=template&id=7c41bf00&scoped=true&external"
import script from "./ArrobaMedellinVerticalCardEvents.vue?vue&type=script&lang=js"
export * from "./ArrobaMedellinVerticalCardEvents.vue?vue&type=script&lang=js"
import style0 from "./ArrobaMedellinVerticalCardEvents.scss?vue&type=style&index=0&id=7c41bf00&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c41bf00",
  null
  
)

export default component.exports